import $ from "jquery";

const EXPLORE_TRIGGER_SELECTOR = "[data-explore-trigger]";
const HERO_BLOCK_SELECTOR = ".hero-block__container";

const EXPLORE_404_TRIGGER_SELECTOR = "[data-explore-404-trigger]";
const FOF_BLOCK_SELECTOR = ".fof__container";

export class LinkActionsModule {
    constructor() {
        this.setupEvents();
    }

    setupEvents() {
        $("body").on("click", EXPLORE_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(HERO_BLOCK_SELECTOR);
            const $heroHeight = $parent.height();

            $("html,body").animate(
                { scrollTop: $parent.offset().top + $heroHeight },
                500,
                "swing"
            );
        });

        $("body").on("click", EXPLORE_404_TRIGGER_SELECTOR, ev => {
            const $targetfof = $(ev.currentTarget);
            const $parentfof = $targetfof.closest(FOF_BLOCK_SELECTOR);
            const $fofHeight = $parentfof.height();
            console.log($targetfof);

            $("html,body").animate(
                { scrollTop: $parentfof.offset().top + $fofHeight },
                500,
                "swing"
            );
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/LinkActionsModule.js